import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class HiFiIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondaryColor: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        secondaryColor: '#fff'
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 147.86">
                <g fill={color}>
                    <rect
                        x={109.57}
                        y={127.85}
                        width={80.86}
                        height={111.3}
                        rx={2.83}
                        ry={2.83}
                        transform="rotate(90 188.035 145.465)"
                        fill={color}
                    />
                    <path d="M182.56 92.49h-65.11a4.765 4.765 0 1 1 0-9.53h65.11a4.765 4.765 0 0 1 0 9.53z" fill={secondaryColor} />
                    <path
                        d="M260.2 73.04a14.29 14.29 0 1 0 14.29 14.29 14.31 14.31 0 0 0-14.29-14.29zM260.2 43.01a8.32 8.32 0 1 0-8.32-8.32 8.33 8.33 0 0 0 8.32 8.32z"
                        fill={color}
                    />
                    <path
                        d="M293.25 0h-67.36a6.75 6.75 0 0 0-6.75 6.75v134.36a6.75 6.75 0 0 0 6.75 6.75h67.36a6.75 6.75 0 0 0 6.75-6.75V6.75A6.75 6.75 0 0 0 293.25 0zm-33 19.23a15.46 15.46 0 1 1-15.46 15.46 15.48 15.48 0 0 1 15.41-15.46zm0 91.93A23.82 23.82 0 1 1 284 87.33a23.85 23.85 0 0 1-23.8 23.82zM41.06 73.04a14.29 14.29 0 1 0 14.29 14.29 14.31 14.31 0 0 0-14.29-14.29z"
                        fill={color}
                    />
                    <path
                        d="M74.11 0H6.75A6.75 6.75 0 0 0 0 6.75v134.36a6.75 6.75 0 0 0 6.75 6.75h67.36a6.75 6.75 0 0 0 6.75-6.75V6.75A6.75 6.75 0 0 0 74.11 0zm-33 19.23A15.46 15.46 0 1 1 25.6 34.69a15.48 15.48 0 0 1 15.46-15.46zm0 91.93a23.82 23.82 0 1 1 23.77-23.83 23.85 23.85 0 0 1-23.82 23.82z"
                        fill={color}
                    />
                    <path d="M41.06 43.01a8.32 8.32 0 1 0-8.32-8.32 8.33 8.33 0 0 0 8.32 8.32z" fill={color} />
                </g>
            </svg>
        );
    }
}

export default withTheme(HiFiIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/HiFiIcon.js